import {connect} from 'react-redux'
import {ActionsRow, commons, Icon, Loader, utils} from "@mc/mc-legacy";
import {CardBody, Col, NavItem, NavLink, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as subjektActions from "../../actions/subjektActions";
import * as polozkaActions from "../../actions/polozkaActions";
import {getIdFromProps} from "../../utils/utils";
import {LinkContainer} from "react-router-bootstrap";
import TablePanel from "../../components/TablePanel";
import {ADMIN_BASE_PATH, SPOLECNOSTI_PATH} from "../../const/routes";
import * as React from "react";
import {Component} from "react";
import {withTranslation, WithTranslation} from "react-i18next";

const {sinkEvent} = commons;

/**
 * Stránka administrace - seznam položek konkrétního ceníku
 */
class SpolecnostCenikPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(subjektActions.fetchSpolecnostDetailIfNeeded(getIdFromProps(this.props)));
        this.props.dispatch(polozkaActions.fetchCenikPolozkyIfNeeded(getIdFromProps(this.props, "idCenik")));
        this.props.dispatch(polozkaActions.fetchCenikySpolecnostiIfNeeded(getIdFromProps(this.props)));
    };


    render() {
        const {spolecnostDetail, cenikPolozkyList,cenikyList, t} = this.props;

        if (!spolecnostDetail.fetched || !cenikPolozkyList.fetched || !cenikyList.fetched) {
            return <Loader/>;
        }

        let content;
        if (cenikPolozkyList.rows.length !== 0) {
            content = cenikPolozkyList.rows.map(cenikPolozka => {
                return <CardBody key={cenikPolozka.id}>
                    <ActionsRow>
                        <Row style={{margin: 0}}>
                            <Col xs={4}>{cenikPolozka.polozka.nazev}</Col>
                            <Col xs={2}>{cenikPolozka.cena}</Col>
                            <Col xs={2}>{cenikPolozka.sleva}</Col>
                        </Row>
                    </ActionsRow>
                </CardBody>;
            });
        } else {
            content = <CardBody><i>{t('no_items_price_list')}</i></CardBody>
        }

        const spolecnost = spolecnostDetail.data;
        const cenikId = getIdFromProps(this.props, "idCenik");
        const cenik = cenikyList.rows?.find((cenik) => cenik.id === cenikId)

        return <AdminPage
            title={t('admin.price_list', {priceListID: cenik?.nazevCenik ? cenik?.nazevCenik : cenikId})}
            subtitle={t('admin.company_price_list', {companyName: spolecnost.nazevSpolecnost, priceListID: cenik?.nazevCenik ? cenik?.nazevCenik : cenikId})}
            tabs={[
                <NavItem key="1">
                    <LinkContainer replace to={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/${spolecnost.id}`}>
                        <NavLink active={false}><Icon icon="home" title={t('admin.company')}/></NavLink>
                    </LinkContainer>
                </NavItem>,
                <NavItem key="2">
                    <LinkContainer replace to={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/${spolecnost.id}/ceniky`}>
                        <NavLink active={false}>{t('admin.price_list_many')}</NavLink>
                    </LinkContainer>
                </NavItem>
            ]}
            content={
                <div>
                    <TablePanel header={
                        <Row>
                            <Col xs={4}>{t('labels.item')}</Col>
                            <Col xs={2}>{t('labels.price')}</Col>
                            <Col xs={2}>{t('discount')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />
    }
}

function mapStateToProps(state) {
    return {
        spolecnostDetail: utils.storeFromArea(state, subjektActions.SPOLECNOST_DETAIL_AREA),
        cenikPolozkyList: utils.storeFromArea(state, polozkaActions.CENIK_POLOZKY_LIST_AREA),
        cenikyList: utils.storeFromArea(state, polozkaActions.CENIKY_SPOLECNOST_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(SpolecnostCenikPage));

